import styled from 'styled-components';
import { Button as ButtonMUI } from '~/elements';
import devices from '../../styles/devices';

export const Content = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 32px 26px 41px;
  min-height: 250px;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.gray400};
  margin-bottom: 21px;
  font-size: 26px;
  text-align: center;
`;

export const Text = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.colors.gray400};
  margin-bottom: 21px;
  font-size: 18px;
`;

export const Consent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Actions = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: ${({ shouldAccept }: { shouldAccept?: boolean }) =>
    shouldAccept ? 'center' : 'space-between'};

  @media (min-width: ${devices.tablet}) {
    flex-direction: row;
  }
`;

export const Button = styled(ButtonMUI)`
  margin: 10px 0 !important;

  @media (min-width: ${devices.tablet}) {
    margin: initial !important;
    max-width: 320px !important;
  }
`;
